import React from 'react';

const Contact = () => {
  return (
    <>
    <div className="ui segment">
      <ul>
        <li>
          <a
            id="email"
            href="mailto: jkinnamancvt@gmail.com"
          >
          Email
          </a>
        </li>
        <li>
          <a href="https://github.com/JoseyKinnaman">
            GitHub
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/josey-kinnaman/">
            LinkedIn
          </a>
        </li>
      </ul>
    </div>
    </>
  );
}

export default Contact;